import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import AddIesaIndustryExcellenceAward from "./AddIesaIndustryExcellenceAward";
import WebService from "../../utility/WebService";

const IesaIndustryExcellenceAward = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [data, setData] = useState<any>(null);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        getData();
    }, [])

    const getData = () => {
        setLoading(true);
        WebService.getAPI({
            action: `iesa-industry-excellence-award/getContent`
        })
            .then((res: any) => {
                setData(res.data);
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    }

    return (
        <>
            <AddIesaIndustryExcellenceAward
                show={showAddModal}
                handleClose={() => {
                    setShowAddModal(false);
                    getData();
                }}
                data={data}
            />
            <div className="events-main">
                <Card className='event-card'>
                    {
                        isLoading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 100 }}>
                                <span className="spinner-border" role="status" aria-hidden="true"></span>
                            </div>
                        ) :
                            <>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div className='page-title'>IESA Industry Excellence Awards</div>
                                    <CustomButton
                                        isLoading={false}
                                        label={data ? 'Edit' : 'Add'}
                                        onClick={() => {
                                            setShowAddModal(true);
                                        }}
                                        style={{ width: 100 }}
                                    />
                                </div>
                                {data?.logo && <div>
                                    <img src={data?.logo} alt="Logo" style={{ maxHeight: 200 }} />
                                </div>}
                                {data?.title && <div className="mt-2"><strong>Title</strong></div>}
                                {data?.title && <div className="font-14">{data?.title}</div>}
                                {data?.about && <div className="mt-2"><strong>About</strong></div>}
                                {data?.about && <div className="font-14" dangerouslySetInnerHTML={{ __html: data?.about }}></div>}
                                {data?.categories && data?.categories.length > 0 && <div className="mt-2"><strong>Categories</strong></div>}
                                {data?.categories && data?.categories.length > 0 && data?.categories.map((item: any, index: number) => (
                                    <div key={index} className="mb-3 p-2" style={{ border: '1px solid #ccc', borderRadius: 5 }}>
                                        {item.image && <div>
                                            <img src={item.image} alt={item.title} style={{ maxHeight: 100 }} />
                                        </div>}
                                        {item.title && <div className="mt-2"><strong>Title</strong></div>}
                                        {item.title && <div className="font-14">{item.title}</div>}
                                        {item.buttonText && <div className="mt-2"><strong>Button Text</strong></div>}
                                        {item.buttonText && <div className="font-14">{item.buttonText}</div>}
                                    </div>
                                ))}
                                {data?.pastGlimpse && data?.pastGlimpse.length > 0 && <div className="mt-2"><strong>Past Glimpses</strong></div>}
                                {data?.pastGlimpse && data?.pastGlimpse.length > 0 && data?.pastGlimpse.map((item: any, index: number) => (
                                    <div key={index} className="mb-3 p-2" style={{ border: '1px solid #ccc', borderRadius: 5 }}>
                                        {item.image && <div>
                                            <img src={item.image} alt={item.title} style={{ maxHeight: 100 }} />
                                        </div>}
                                        {item.link && <div className="mt-2"><strong>Link</strong></div>}
                                        {item.link && <div className="font-14">{item.link}</div>}
                                        {item.buttonText && <div className="mt-2"><strong>Button Text</strong></div>}
                                        {item.buttonText && <div className="font-14">{item.buttonText}</div>}
                                    </div>
                                ))}
                                {data?.pastWinners && data?.pastWinners.length > 0 && <div className="mt-2"><strong>Past Winners</strong></div>}
                                {data?.pastWinners && data?.pastWinners.length > 0 && data?.pastWinners.map((item: any, index: number) => (
                                    <div key={index} className="mb-3 p-2" style={{ border: '1px solid #ccc', borderRadius: 5 }}>
                                        {item.file && <div>
                                            <a href={item.file} target="_blank" rel="noopener noreferrer" className="font-14">View File</a>
                                        </div>}
                                        {item.title && <div className="mt-2"><strong>Title</strong></div>}
                                        {item.title && <div className="font-14">{item.title}</div>}
                                    </div>
                                ))}
                                {data?.video && data?.video.length > 0 && <div className="mt-2"><strong>Videos</strong></div>}
                                {data?.video && data?.video.length > 0 && <div className="d-flex flex-wrap"> {data?.video.map((item: any, index: number) => (
                                    <div key={index} className="mb-3 p-2 ms-2" style={{ border: '1px solid #ccc', borderRadius: 5 }}>
                                        <video width="320" height="240" controls>
                                            <source src={item.link} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                ))}
                                </div>}
                            </>
                    }
                </Card>
            </div>
        </>
    )
}

export default IesaIndustryExcellenceAward;